import { Controller } from "@hotwired/stimulus"

export const options = {
  locale: 'de',
  format: 'L',
  useCurrent: false,
}

export default class extends Controller {
  connect(e) {
     $(this.element).datetimepicker(options)
  }
}
